<template>
    <InjectMicroFrontendApp
        app="messenger-mf-chatbox"
        :props="{projectConversationId, immersion: immersionId}"
        class="messenger-mf"
        data-testid="mf-chatbox"
    >
        <template #loading>
            <VJoyBlockSkeleton v-for="index in 4" :key="index" class="messenger-mf__skeleton-section" />
        </template>
    </InjectMicroFrontendApp>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {InjectMicroFrontendApp} from '#components';
    import {VJoyBlockSkeleton} from '@maltjoy/core-vue';
    import {useUserStore} from '~/common/stores';

    const props = defineProps<{
        projectConversationId: string;
        clientIdentityId: string;
        isClientOwner: boolean;
    }>();

    const userStore = useUserStore();

    const immersionId = computed(() => {
        if (!props.isClientOwner && userStore.isPlatformAdmin) {
            return props.clientIdentityId;
        }
        return undefined;
    });
</script>

<style lang="scss" scoped>
    .messenger-mf {
        flex: 1 1 auto;
        overflow: hidden;
        padding-top: var(--joy-core-spacing-4);

        &__skeleton-section {
            height: 24px;
            margin-bottom: var(--joy-core-spacing-4);
        }
    }
</style>
